const constants = require('@/util/constants')
require('./config')

/**
 * 获取-待我回复-工单
 *
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getForMeReply (page, size, successcb, failedcb) {
  axios.get('/api/ticket/query/formereply', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取-等待回复(待对方回复)-工单
 *
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getToBeReplied(page, size, successcb, failedcb) {
  axios.get('/api/ticket/query/tobereplied', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取-已忽略-工单
 *
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getIgnore(page, size, successcb, failedcb) {
  axios.get('/api/ticket/query/ignore', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取-已解决-工单
 *
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getDone (page, size, successcb, failedcb) {
  axios.get('/api/ticket/query/done', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取-访客关闭-工单
 *
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getClosed(page, size, successcb, failedcb) {
  axios.get('/api/ticket/query/closed', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 客服后台创建工单
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createTicket (ticket, successcb, failedcb) {
  axios.post('/api/ticket/create2', {
    // 'tid': ticket.tid,
    'title': ticket.title,
    'content': ticket.content,
    'cid': ticket.cid,
    'attachments': ticket.attachments,
    'urgent': ticket.urgent,
    'status': ticket.status,
    'handlerType': ticket.handlerType,
    'wid': ticket.wid,
    'uid': ticket.uid,
    'ttid': ticket.ttid,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新工单
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function updateTicket (ticket, successcb, failedcb) {
//   axios.post('/api/ticket/update', {
//     'tid': ticket.tid,
//     'title': ticket.title,
//     'content': ticket.content,
//     'cid': ticket.cid,
//     'attachments': ticket.attachments,
//     'urgent': ticket.urgent,
//     'status': ticket.status,
//     'handlerType': ticket.handlerType,
//     'wid': ticket.wid,
//     'uid': ticket.uid,
//     'client': constants.HTTP_CLIENT
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

// 忽略
export function ignoreTicket (tid, successcb, failedcb) {
  axios.post('/api/ticket/do/ignore', {
    tid,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// 已解决
export function doneTicket (tid, successcb, failedcb) {
  axios.post('/api/ticket/do/done', {
    tid,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// /**
//  * 获取-待回复-工单
//  *
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function tobereplied (page, size, successcb, failedcb) {
//   axios.get('/api/ticket/tobereplied', {
//     params: {
//       'page': page,
//       'size': size,
//       'client': constants.HTTP_CLIENT
//     }
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

// /**
//  * 获取-我创建-工单
//  *
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function createdByMe (page, size, successcb, failedcb) {
//   axios.get('/api/ticket/createdByMe', {
//     params: {
//       'page': page,
//       'size': size,
//       'client': constants.HTTP_CLIENT
//     }
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

// /**
//  * 获取-我处理-工单
//  *
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function processingByMe (page, size, successcb, failedcb) {
//   axios.get('/api/ticket/processingByMe', {
//     params: {
//       'page': page,
//       'size': size,
//       'client': constants.HTTP_CLIENT
//     }
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

// /**
//  * 获取-待认领-工单
//  *
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function unclaim (page, size, successcb, failedcb) {
//   axios.get('/api/ticket/unclaim', {
//     params: {
//       'page': page,
//       'size': size,
//       'client': constants.HTTP_CLIENT
//     }
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

// /**
//  * 认领
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function claimTicket (tid, successcb, failedcb) {
//   axios.post('/api/ticket/claim', {
//     tid,
//     'client': constants.HTTP_CLIENT
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }
